<template>
  <div class="inline-block rounded-md bg-white shadow-xs">
    <div class="py-1 relative inline-block">
      <RowUomButton name="materials" unit="Materials" @setUom="$emit('setMaterials')"></RowUomButton>
      <div class="border-b"></div>
      <!--<RowUomButton name="time" unit="Seconds" @setUom="$emit('setTime', 'Seconds')"></RowUomButton>-->
      <!--<RowUomButton name="time" unit="Minutes" @setUom="$emit('setTime', 'Minutes')"></RowUomButton>-->
      <RowUomButton name="time" unit="Hours" @setUom="$emit('setTime', 'Hours')"></RowUomButton>
      <RowUomButton name="time" unit="Days" @setUom="$emit('setTime', 'Days')"></RowUomButton>
      <!--<RowUomButton name="time" unit="Weeks" @setUom="$emit('setTime', 'Weeks')"></RowUomButton>-->
    </div>
  </div>
</template>

<script>
import RowUomButton from '@/components/row/uom/RowUomButton'

export default {
  name: 'RowUomMenu',
  components: {
    RowUomButton
  }
};
</script>